import { ProductQuery } from "../profileTyps";
import { formatDateTime } from "../../../../utils/formatDateTime";
import whatshapPng from "../../../../assets/profile/quotationTrackerImages/Whatsapp.png";
import defaultImage from "../../../../assets/defaultImage.svg";
import { AiOutlineClockCircle, AiFillCheckCircle } from "react-icons/ai";
import { IoIosCloseCircle } from "react-icons/io";
import { useNavigate } from "react-router-dom";
type DataProps = {
    item: ProductQuery;
    handleModalOpen: (price: number | null, validity?: string | null) => void;
};
const steps = ["pending", "on going", "yet to complete", "complete"];
const statusOrder = [
    "pending",
    "on going",
    "yet to complete",
    "complete",
    "cancelled",
];

const getLabel = (status: any) => {
    switch (status) {
        case "pending":
            return "Pending";
        case "on going":
            return "On Going";
        case "yet to complete":
            return "Yet to Complete";
        case "complete":
            return "Completed";
        case "cancelled":
            return "Cancelled";
        default:
            return "";
    }
};

const QuotationTrackerData = ({ item, handleModalOpen }: DataProps) => {
    const navigate = useNavigate()
    const handleItemClick = (id: string | null, name: string | null) => {
        navigate(`/product/${id}/${name}`, { state: { id } });
    };
    return (
        <div className=" font-poppins bg-gray-50 sm:bg-white sm:font-inter w-full h-auto rounded-md  shadow-sm sm;border mb-5 p-2 sm:border  sm:p-4 flex flex-col gap-3 sm:py-5 mt-2">
            <div className="flex flex-row w-full items-start  sm:justify-between">
                <h2 className=" hidden sm:block text-sm sm:text-2xl font-bold mb-2 sm:mb-0">
                    Query Details
                </h2>
                <div className=" border sm:border-none p-1 px-3 sm:p-0 rounded-full bg-white  text-[10px] sm:text-xs flex justify-between w-full sm:w-fit   sm:justify-center sm:flex-col items-center gap-1">
                    <span className="text-[#7B7B7B]">
                        {" "}
                        <span className=" font-bold text-[#141414]">
                            Sales Person Name :
                        </span>{" "}
                        {item?.salesPersonId?.name
                            ? item?.salesPersonId?.name
                            : "Not issue yet"}
                    </span>
                    <span className="text-[#7B7B7B] flex gap-1 ">
                        <img
                            src={whatshapPng}
                            className="h-3 w-3 sm:h-4 sm:w-4 object-contain"
                            alt=""
                        />
                        {item?.salesPersonId?.phoneNumber
                            ? item?.salesPersonId?.phoneNumber
                            : "Not issue yet"}
                    </span>
                </div>
                <button
                    disabled={item?.status !== "complete"}
                    onClick={() =>
                        handleModalOpen(
                            item?.productDetails[0]?.price?.price,
                            formatDateTime(item?.productDetails[0]?.price?.validTime)
                        )
                    }
                    className={`hidden sm:block text-xs font-medium px-3 py-2 rounded-md transition-colors duration-300 ease-in-out ${item?.status === "complete"
                        ? "bg-gradient-to-r from-green-500 to-green-700 text-white cursor-pointer"
                        : "bg-gradient-to-r from-gray-300 to-gray-500 text-gray-200 cursor-not-allowed"
                        }`}>
                    Price & Validity
                </button>
            </div>
            <div className="h-24 w-full gap-2 flex sm:hidden "
             onClick={() => handleItemClick(item?.productDetails[0].productId, item?.productDetails[0].productName)}
            >
                <img
                    src={
                        item?.productDetails[0]?.productImage[0] || defaultImage
                    }
                    alt="abc"
                    className="max-w-20 w-full h-24 rounded-md border relative object-cover cursor-pointer"
                />
                <div className=" space-y-[2px] relative w-full">
                    <h1 className="text-[12px] font-bold">
                        {item?.productDetails[0].productName}
                    </h1>
                    <p className="text-[10px] text-gray-600">
                        <b>Date</b>: {formatDateTime(item?.date)}
                    </p>
                    <p className="text-[10px] text-gray-600">
                        <b>Quantitys</b> : {item?.productDetails[0].quantity}{" "}
                        {item?.unit?.name}
                    </p>
                    <button
                        disabled={item?.status !== "complete"}
                        onClick={() =>
                            handleModalOpen(
                                item?.productDetails[0]?.price?.price,
                                formatDateTime(item?.productDetails[0]?.price?.validTime)
                            )
                        }
                        className={`text-[10px] ml-auto sm:text-sm font-medium mt-auto  px-3 py-1 rounded-md absolute right-1 bottom-1  mx-auto focus:ring-2 sm:hidden transition-colors duration-300 ease-in-out ${item?.status === "complete"
                            ? "bg-gradient-to-r from-green-500 to-green-700 text-white cursor-pointer"
                            : "bg-gradient-to-r from-gray-300 to-gray-500 text-gray-200 cursor-not-allowed"
                            }`}>
                        Price & Validity
                    </button>
                </div>
            </div>
            <ol className="flex items-center w-full mx-auto sm:hidden relative">
                {steps.map((step, index) => {
                    const isFinalStep = index === steps.length - 1;
                    const currentIndex = statusOrder.indexOf(item.status);
                    const stepIndex = statusOrder.indexOf(step);
                    const isCompleted = stepIndex < currentIndex;
                    const isCurrent = stepIndex === currentIndex;
                    const isCancelled =
                        item.status === "cancelled" && isFinalStep;

                    const getStepIcon = () => {
                        if (isCancelled)
                            return (
                                <IoIosCloseCircle className="text-red-500 h-6 w-6" />
                            );
                        if (
                            (isCompleted && !isCurrent) ||
                            (isCurrent && item.status === "complete")
                        ) {
                            return (
                                <AiFillCheckCircle className="text-green-600 h-6 w-6" />
                            );
                        }
                        if (isCurrent)
                            return (
                                <AiOutlineClockCircle className="text-blue-500 h-6 w-6" />
                            );
                        return (
                            <AiOutlineClockCircle className="text-gray-400 h-6 w-6" />
                        );
                    };

                    return (
                        <li
                            key={step}
                            className="relative flex-1 flex items-center justify-center">
                            {!isFinalStep && (
                                <span
                                    className={`absolute top-1/2 left-1/2 h-1 ${isCompleted
                                        ? "bg-[#16A085]"
                                        : "bg-[#AEAEAE]"
                                        } -translate-y-1/2 w-full z-0`}
                                />
                            )}
                            <div className="relative z-10 flex items-center justify-center bg-blue-100 rounded-full h-6 w-6 ">
                                {getStepIcon()}
                            </div>

                            <p className="absolute top-8 sm:top-10 left-1/2 -translate-x-1/2 flex flex-col gap-1 sm:gap-2 items-center w-[90px] sm:w-[120px] text-center">
                                <span className="font-medium text-[10px] sm:text-xs">
                                    {isCancelled ? "cancelled" : getLabel(step)}
                                </span>
                                {
                                    isFinalStep && (
                                        <span className="text-[8px] sm:text-xs text-[#868383]">
                                            {item.completedAt &&
                                                formatDateTime(item?.completedAt)}
                                        </span>
                                    )
                                }
                            </p>
                        </li>
                    );
                })}
            </ol>
            <div className=" hidden w-full sm:flex gap-4 items-center ">
                <img
                    onClick={() => handleItemClick(item?.productDetails[0].productId, item?.productDetails[0].productName)}
                    src={
                        item?.productDetails[0]?.productImage[0] || defaultImage
                    }
                    alt="abc"
                    className="max-w-20 w-full h-24 rounded-md border relative object-cover cursor-pointer"
                />
                <div className=" space-y-[2px] relative w-full">
                    <h5 className="text-sm font-bold">
                        {item?.productDetails[0]?.productName}
                    </h5>
                    <div className="text-[#605959] font-medium text-sm hidden sm:block">
                        Date : {formatDateTime(item?.date)}
                    </div>
                    <div className="text-[#605959] font-medium text-sm hidden sm:block">
                        <span className="font-bold">Quantity</span> :{" "}
                        {item?.productDetails[0].quantity} {item?.unit?.name}
                    </div>
                </div>
            </div>
            <div className="w-full p-4 relative sm:p-4 sm:border border-gray-300 rounded-md sm:h-[110px]">
                <ol className=" hidden sm:flex items-center w-full mx-auto relative">
                    {steps?.map((step, index) => {
                        const isFinalStep = index === steps.length - 1;
                        const currentIndex = statusOrder.indexOf(item.status);
                        const stepIndex = statusOrder.indexOf(step);
                        const isCompleted = stepIndex < currentIndex;
                        const isCurrent = stepIndex === currentIndex;
                        const isCancelled =
                            item.status === "cancelled" && isFinalStep;

                        const getStepIcon = () => {
                            if (isCancelled)
                                return (
                                    <IoIosCloseCircle className="text-red-500 h-6 w-6" />
                                );
                            if (
                                (isCompleted && !isCurrent) ||
                                (isCurrent && item.status === "complete")
                            ) {
                                return (
                                    <AiFillCheckCircle className="text-green-600 h-6 w-6" />
                                );
                            }
                            if (isCurrent)
                                return (
                                    <AiOutlineClockCircle className="text-blue-500 h-6 w-6" />
                                );
                            return (
                                <AiOutlineClockCircle className="text-gray-400 h-6 w-6" />
                            );
                        };

                        return (
                            <li
                                key={step}
                                className="relative flex-1 flex items-center justify-center">
                                {!isFinalStep && (
                                    <span
                                        className={`absolute top-1/2 left-1/2 h-1 ${isCompleted
                                            ? "bg-[#16A085]"
                                            : "bg-[#AEAEAE]"
                                            } -translate-y-1/2 w-full z-0`}
                                    />
                                )}

                                {/* <span
                                    className={`absolute top-1/2 left-1/2 h-1 w-full -translate-y-1/2 z-0 ${currentIndex > index + 1 ? "bg-[#16A085]" : "bg-[#AEAEAE]"
                                        }`}
                                /> */}
                                <div className="relative z-10 flex items-center justify-center bg-blue-100 rounded-full h-6 w-6 sm:h-8 sm:w-8">
                                    {getStepIcon()}
                                </div>

                                <p className="absolute top-8 sm:top-10 left-1/2 -translate-x-1/2 flex flex-col gap-1 sm:gap-2 items-center w-[90px] sm:w-[120px] text-center">
                                    <span className="font-medium text-[10px] sm:text-xs">
                                        {isCancelled
                                            ? "Cancelled"
                                            : getLabel(step)}
                                    </span>
                                    {
                                        isFinalStep && (
                                            <span className="text-[10px] text-[#868383] whitespace-nowrap">
                                                {item.completedAt &&
                                                    formatDateTime(
                                                        item?.completedAt
                                                    )}
                                            </span>
                                        )
                                    }
                                </p>
                            </li>
                        );
                    })}
                </ol>
            </div>
        </div>
    );
};

export default QuotationTrackerData;
